<template>
  <header class="mt-3">
    <div class="container">
      <div class="header-title">
      <h1>Hunger is a good cook.</h1>
      <p class="text-muted">velit nam blanditiis quia id tempora tempore? Sequi, facilis tempora?</p>
      <button class="btn rounded-pill">get your recipe!</button>
    </div>
     <div class="header-hero mt-4">
      <div class="row">
        <div class="col-5">
          <div class="hero-img-big ">
            <img class="w-100" src="../assets/images/pict5.jpg" alt="">
          </div>
        </div>
        <div class="col-4 p-0">
          <div class="row">
            <div class="col-12">
              <div class="hero-img-1 ">
              <img class="w-100" src="../assets/images/pict7.jpg" alt="">
            </div>
            </div>
            <div class="col-7 pt-2">
              <div class="hero-img-2 ">
              <img class="w-100" src="../assets/images/pict3.jpg" alt="">
            </div>
            </div>
            <div class="col-5 pt-2 pl-0">
              <div class="hero-img-3 ">
              <img class="w-100" src="../assets/images/pict6.jpg" alt="">
            </div>
            </div>
            </div>
          
        </div>
        <div class="col-3">
          <div class="hero-img-big">
            <img class="w-100" src="../assets/images/pict4.jpg" alt="">
          </div>
        </div>
      </div>
    </div>
    </div>

   
    
  </header>
</template>

<script>
export default {
name: 'Header'
}
</script>

<style>

</style>